import { LanguageLowercase } from 'store/app/types.ts'
import resources from 'translations/dutch'
import { ContactMode, ELProduct, NGProduct, PhysicalMeterType, Direction, TimeframeCode, LANGUAGES } from '@boltenergy-be/shared'

// GENERAL TYPES

export type Contact = {
  contactMode: ContactMode
  email: string
  phoneMobile: string
}

export type Email = {
  subject: string
  message: string
}

export type InvoiceTypeTranslationKey = keyof typeof resources.invoices.invoiceTypes

export type Person = {
  firstName: string
  lastName: string
  birthDate?: string
}

export type PreviousIndex = {
  meterNumber: string
  meterType: PhysicalMeterType
  registers: Register[]
}

export type LowerCaseBiLingualValue<T> = {
  [LanguageLowercase.NL]: T
  [LanguageLowercase.FR]: T
}

export type BiLingualValue<T> = {
  [LANGUAGES.NL]: T
  [LANGUAGES.FR]: T
}

export type Product = {
  electricity: ELProduct
  gas: NGProduct
}

export type Register = {
  registerName: string
  direction: Direction
  timeframeCode: TimeframeCode
}

export type Town = {
  postalCode: number
  townName: string
  townCode: number
  mainTownName: string
  geoCode: string
  languageCode: 'NL' | 'FR'
}

// ENUMS

export enum SimplifiedContractStatus {
  INACTIVE = 'inactive',
  IN_PROGRESS = 'inProgress',
  CANCELLED = 'cancelled',
  TERMINATED = 'terminated',
  ACTIVE = 'active'
}

export enum ProductType {
  ELECTRICITY = 'electricity',
  GAS = 'gas'
}
